import styled from "styled-components";

const TextDivider = styled.div`
  margin: ${({ theme }) => theme.space[4]} ${({ theme }) => theme.space[2]};
  font-size: ${({ theme }) => theme.fontSizes[0]};
  text-align: center;
  text-transform: lowercase;
  overflow: hidden;

  &::before,
  &::after {
    content: "";
    position: relative;
    display: inline-block;
    width: 50%;
    height: 1px;
    background-color: ${({ theme }) => theme.colors.secondary};
    vertical-align: middle;
  }

  &::before {
    right: ${({ theme }) => theme.space[2]};
    margin-left: -50%;
  }

  &::after {
    left: ${({ theme }) => theme.space[2]};
    margin-right: -50%;
  }
`;

export default TextDivider;
